import React from 'react';

const EvidenceGrid = ({ data }) => {
    const flatEvidence = data?.flat_evidence || [];

    if (!flatEvidence || flatEvidence.length === 0) {
        return (
            <div className="card evidence-container-card">
                <h3>Analysis & Evidence</h3>
                <div className="no-evidence-message">
                    <p>Established knowledge or visual synthesis remains the primary source for this analysis.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="card evidence-container-card">
            <h3>Analysis & Evidence</h3>
            <div className="evidence-feed">
                {flatEvidence.map((item, idx) => {
                    if (item.type === 'news') {
                        const news = item.data;
                        const domain = news.url ? new URL(news.url).hostname : '';
                        const faviconUrl = `https://www.google.com/s2/favicons?domain=${domain}&sz=64`;
                        const sourceName = typeof news.source === 'object' ? (news.source.name || news.source.id) : news.source;

                        return (
                            <a key={`ev-${idx}`} href={news.url} target="_blank" rel="noreferrer" className="feed-item">
                                <div className="feed-item-header">
                                    <img src={faviconUrl} alt="" className="source-icon" onError={(e) => e.target.style.display = 'none'} />
                                    <div className="source-info">
                                        <span className="source-name">{sourceName || "News Source"}</span>
                                        {news.publishedAt && <span className="feed-timestamp">{new Date(news.publishedAt).toLocaleDateString()}</span>}
                                    </div>
                                </div>

                                {news.imageUrl || news.urlToImage ? (
                                    <img src={news.imageUrl || news.urlToImage} alt="" className="feed-item-image" />
                                ) : null}

                                <div className="feed-item-body">
                                    <h5 className="feed-item-title">{news.title}</h5>
                                    {news.description && (
                                        <p className="feed-item-description">{news.description}</p>
                                    )}
                                    <div className="feed-item-link-hint">
                                        Read Full Article ↗
                                    </div>
                                </div>
                            </a>
                        );
                    } else if (item.type === 'factcheck') {
                        const fc = item.data;
                        const fcClaims = fc.factcheck?.claims || [];
                        const firstClaim = fcClaims[0];
                        const fcUrl = firstClaim?.claimReview?.[0]?.url || '#';
                        const fcTitle = firstClaim?.text || fc.claim || "Fact Check";
                        const fcRating = firstClaim?.claimReview?.[0]?.textualRating;
                        const fcPublisher = firstClaim?.claimReview?.[0]?.publisher?.name;
                        const domain = fcUrl !== '#' ? new URL(fcUrl).hostname : '';
                        const faviconUrl = domain ? `https://www.google.com/s2/favicons?domain=${domain}&sz=64` : null;

                        return (
                            <a key={`ev-${idx}`} href={fcUrl} target="_blank" rel="noreferrer" className="feed-item">
                                <div className="feed-item-header">
                                    {faviconUrl && <img src={faviconUrl} alt="" className="source-icon" onError={(e) => e.target.style.display = 'none'} />}
                                    <div className="source-info">
                                        <span className="source-name">{fcPublisher || "Verified Fact Checker"}</span>
                                    </div>
                                </div>

                                <div className="feed-item-body">
                                    {fcRating && (
                                        <div className="evidence-header">
                                            <span className={`rating-badge rating-${fcRating.toLowerCase().replace(/\s+/g, '-')}`}>
                                                {fcRating.toUpperCase()}
                                            </span>
                                        </div>
                                    )}
                                    <h5 className="feed-item-title">{fcTitle}</h5>
                                    <div className="feed-item-link-hint">
                                        View Fact Check Analysis
                                    </div>
                                </div>
                            </a>
                        );
                    } else if (item.type === 'gdelt') {
                        const event = item.data;
                        return (
                            <a key={`ev-${idx}`} href={event.url || '#'} target="_blank" rel="noreferrer" className="feed-item">
                                <div className="feed-item-header">
                                    <span className="source-name">GDELT Project</span>
                                </div>
                                <div className="feed-item-body">
                                    <h5 className="feed-item-title">{event.title || "Global Event Match"}</h5>
                                    <div className="feed-item-link-hint">
                                        View Context ↗
                                    </div>
                                </div>
                            </a>
                        );
                    }
                    return null;
                })}
            </div>
        </div>
    );
};

export default EvidenceGrid;
